import { api } from '@/api/client'

/**
 * Relatório de custo por conta (TASK-2772).
 *
 * Fonte única do backend (`build_cost_report`) — a MESMA leitura que alimenta
 * a tela e o PDF, garantindo que os números batem.
 */
export interface CostReportServiceRow {
  service: string
  total_usd: number
  /** custo por mês (mesmas chaves de `months`; 0.0 onde não houve gasto) */
  by_month: Record<string, number>
}

export interface CostReportResponse {
  account_id: string
  account_name: string | null
  currency: string
  as_of: string | null
  is_partial: boolean
  months: string[]
  monthly_totals: { month: string; total_usd: number }[]
  services: CostReportServiceRow[]
  grand_total_usd: number
  cost_available: boolean
  error_code: string | null
}

/**
 * GET /api/v1/finops/accounts/{accountId}/cost-report
 *
 * `months` = janela de meses (default 4 = 3 fechados + corrente parcial).
 */
export async function fetchCostReport(p: {
  accountId: string
  months?: number
}): Promise<CostReportResponse> {
  const months = p.months ?? 4
  const url = `/v1/finops/accounts/${encodeURIComponent(p.accountId)}/cost-report?months=${months}`
  const r = await api.get<CostReportResponse>(url, { timeout: 95000 })
  return r.data
}

/**
 * POST .../cost-report/export-pdf → gera o PDF (template Amazonas Inovare),
 * sobe no S3 e devolve uma presigned URL (válida 1h). Mesma fonte da tela.
 */
export async function exportCostReportPdf(p: {
  accountId: string
  months?: number
}): Promise<{ url: string; expires_in: number }> {
  const months = p.months ?? 4
  const url = `/v1/finops/accounts/${encodeURIComponent(p.accountId)}/cost-report/export-pdf`
  const r = await api.post<{ url: string; expires_in: number }>(
    url,
    { months },
    { timeout: 95000 },
  )
  return r.data
}
